// extracted by mini-css-extract-plugin
module.exports = {"container":"PriceInput_container__UoTLp","inputArea":"PriceInput_inputArea__g1D_p","maxText":"PriceInput_maxText__ee0iw","buttonText":"PriceInput_buttonText__OMUBz"};